import { buildRunIdParam } from 'src/common/helpers/GQLRequestsHelper/buildRunIdParam';

import { MobileSdkTestFilterOptionsQueryVariables } from '../MobileSdkTestFilterOptions.generated';

export const buildMobileSdkTestFilterOptionsVariables = (
	testId: string
): Partial<MobileSdkTestFilterOptionsQueryVariables> => {
	const trimmedTestId = testId.trim();
	if (!trimmedTestId) {
		return {};
	}

	return {
		testId: buildRunIdParam(trimmedTestId).runId
	};
};
